import { render, staticRenderFns } from "./react-button.vue?vue&type=template&id=385c866a&scoped=true&"
import script from "./react-button.vue?vue&type=script&lang=js&"
export * from "./react-button.vue?vue&type=script&lang=js&"
import style0 from "./react-button.vue?vue&type=style&index=0&id=385c866a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "385c866a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VIcon})
